export default "__VITE_ASSET__CJial9ZD__"